document.addEventListener('DOMContentLoaded', function () {
    // Get the registration form and submit button
    if (document.querySelector('form.woocommerce-form-register')) {
        var registrationForm = document.querySelector('form.woocommerce-form-register');
        var registerButton = registrationForm.querySelector('button[type="submit"]');

        // Get all required form fields
        var requiredFields = registrationForm.querySelectorAll('.input-text');
        var passwordField = registrationForm.querySelector('input[name="password"]');
        var emailField = registrationForm.querySelector('input[type="email"]'); // Get the email field

        // Error message display elements
        var passwordErrorContainer = document.createElement('div');
        passwordErrorContainer.classList.add('password-error');
        passwordField.parentNode.insertBefore(passwordErrorContainer, passwordField.nextSibling);

        var emailErrorContainer = document.createElement('div');
        emailErrorContainer.classList.add('email-error');
        emailField.parentNode.insertBefore(emailErrorContainer, emailField.nextSibling); // Insert email error container


        // Function to check if all required fields are filled
        function checkRequiredFields() {
            var allFilled = true;
            requiredFields.forEach(function (field) {
                if (field.value !== undefined && field.value.toString().trim() === '') {
                    allFilled = false;
                }
            });
            return allFilled;
        }

        // Function to check password strength
        function checkPasswordStrength(password) {
            var errors = [];

            if (password.length < 8) {
                errors.push("Password must be at least 8 characters long.");
            }
            if (!/[A-Z]/.test(password)) {
                errors.push("Password must contain at least one uppercase letter.");
            }
            if (!/[0-9]/.test(password)) {
                errors.push("Password must contain at least one number.");
            }
            if (!/[^a-zA-Z0-9\s]/.test(password)) {
                errors.push("Password must contain at least one special character.");
            }
            return errors; // return an array of errors.
        }

        // Function to validate email format
        function isValidEmail(email) {
            // Basic email validation regex (you can use a more robust one if needed)
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }

        // Function to display password errors
        function displayPasswordErrors(errors) {
            passwordErrorContainer.innerHTML = ''; // Clear previous errors

            if (errors.length > 0) {
                errors.forEach(function (error) {
                    var errorElement = document.createElement('p');
                    errorElement.textContent = error;
                    passwordErrorContainer.appendChild(errorElement);
                    passwordErrorContainer.style.color = 'red'; // Set error text to red
                });
            } else {
                passwordErrorContainer.innerHTML = ''; // Clear errors
            }
        }

        // Function to display email errors
        function displayEmailErrors(isValid) {
            emailErrorContainer.innerHTML = ''; // Clear previous errors
            if (!isValid) {
                var errorElement = document.createElement('p');
                errorElement.textContent = "Please enter a valid email address.";
                emailErrorContainer.appendChild(errorElement);
                emailErrorContainer.style.color = 'red';
            }
        }


        // Function to update button state
        function updateButtonState() {
            if (checkRequiredFields() && checkPasswordStrength(passwordField.value).length === 0 && isValidEmail(emailField.value)) {
                registerButton.disabled = false;
            } else {
                registerButton.disabled = true;
            }
        }

        // Disable the button initially
        registerButton.disabled = true;

        // Add event listeners to each required field
        requiredFields.forEach(function (field) {
            field.addEventListener('input', function () {
                updateButtonState();
            });
        });

        // Add event listener to the password field for real-time validation
        if (passwordField) {
            passwordField.addEventListener('input', function () {
                var password = passwordField.value;
                var passwordErrors = checkPasswordStrength(password);
                displayPasswordErrors(passwordErrors);
                updateButtonState();
            });
        }

        // Add event listener to the email field for validation
        if (emailField) {
            emailField.addEventListener('input', function () {
                var email = emailField.value;
                var isEmailValid = isValidEmail(email);
                displayEmailErrors(isEmailValid);
                updateButtonState();
            });
        }
    }
});
